export const getPaymentMethodType = payment => {
    if (!payment || !payment.type) {
        return ' ';
    }

    return payment.type === 'card' ? payment.cardType || payment.type : payment.type;
};
